// ABOUTME: Waitlist page using Clerk's built-in Waitlist component
// ABOUTME: Shown pre-launch so visitors can join the waitlist

"use client"

import { Waitlist } from "@clerk/nextjs"
import Link from "next/link"
import { DraftyLogo } from "@/components/drafty-logo"

export default function WaitlistPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <nav className="py-6 md:py-8 px-6 md:px-8">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link href="/" className="block">
            <DraftyLogo
              width={140}
              height={23}
              animate={false}
              className="text-gray-900"
            />
          </Link>
          <Link
            href="/sign-in"
            className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
          >
            Sign in
          </Link>
        </div>
      </nav>

      <div className="flex-1 flex items-center justify-center px-6 pb-16">
        <Waitlist />
      </div>
    </div>
  )
}
